'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const CollapsibleSummary = renderWithRef('CollapsibleSummary', null, (e, l)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: l,
        classNames: [
            'swan-collapsible-summary'
        ],
        props: e,
        children: e.children
    }));

export { CollapsibleSummary };
